export default {"src":"/_next/static/media/brd.da02f42b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};